import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4db2739f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "df-table"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", {
  class: "standard white"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "magrin-style",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%"
  }
}, "Product Name")])]), /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  style: {
    "width": "153px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "magrin-style",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%"
  }
}, "Buybox Status")])]), /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  style: {
    "width": "300px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "product-package-style",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%"
  }
}, "Price")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cells"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell",
  style: {
    "width": "140px",
    "padding": "8px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title dark-grey",
  style: {
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%"
  }
}, "Buybox/Compet.")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell",
  style: {
    "width": "160px",
    "padding": "8px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title dark-grey",
  style: {
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%"
  }
}, "My price")])])]), /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  style: {
    "width": "116px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "magrin-style",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%"
  }
}, "Margin")])]), /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  style: {
    "width": "88px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "magrin-style",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%",
    "opacity": "0.56"
  }
}, "Tax")])]), /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  style: {
    "width": "299px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "product-package-style",
  style: {
    "padding": "8px",
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%",
    "opacity": "0.56"
  }
}, "Fees")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cells"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell",
  style: {
    "width": "88px",
    "padding": "12px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%",
    "opacity": "0.56",
    "text-align": "right !important"
  }
}, "Referral")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell",
  style: {
    "width": "123px",
    "padding": "12px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%",
    "opacity": "0.56",
    "flex": "1 0 auto",
    "text-align": "right !important"
  }
}, "FBA")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell",
  style: {
    "width": "88px",
    "padding": "12px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%",
    "opacity": "0.56",
    "flex": "1 0 auto",
    "text-align": "right !important"
  }
}, "Prep")])])]), /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  style: {
    "width": "88px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "magrin-style",
  style: {
    "color": "#757575",
    "font-family": "Figtree",
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "500",
    "line-height": "130%",
    "opacity": "0.56"
  }
}, "COGS")])])])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pricing_and_margin_data_content_row = _resolveComponent("pricing-and-margin-data-content-row");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["df", {
      blur: $props.dataLoading
    }])
  }, [_createElementVNode("table", _hoisted_1, [_hoisted_2, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
    return _openBlock(), _createBlock(_component_pricing_and_margin_data_content_row, {
      key: `${index}`,
      uniqueIndex: index,
      item: item,
      accountProvider: $props.accountProvider
    }, null, 8, ["uniqueIndex", "item", "accountProvider"]);
  }), 128))])])], 2);
}